(function() {
  function initColorSelector(root) {
    if (!root || root.dataset.cdcColorSelectorInitialized === 'true') return;

    root.dataset.cdcColorSelectorInitialized = 'true';

    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-color-trigger]'));
    var images = Array.prototype.slice.call(root.querySelectorAll('[data-color-image]'));

    if (!triggers.length || !images.length) return;

    function activateColor(id) {
      triggers.forEach(function(trigger) {
        var isActive = trigger.getAttribute('data-color-trigger') === id;

        trigger.classList.toggle('is-active', isActive);
        trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      images.forEach(function(image) {
        var isActive = image.getAttribute('data-color-image') === id;

        image.classList.toggle('is-active', isActive);
      });
    }

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        activateColor(trigger.getAttribute('data-color-trigger'));
      });
    });

    activateColor(triggers[0].getAttribute('data-color-trigger'));
  }

  function initAllColorSelectors() {
    var roots = document.querySelectorAll('[data-cdc-color-selector]');

    roots.forEach(function(root) {
      initColorSelector(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllColorSelectors);
  } else {
    initAllColorSelectors();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('[data-cdc-color-selector]');

    if (root) {
      initColorSelector(root);
    }
  });
})();